import { inject, Injectable } from '@angular/core';
import { SofToastService } from '@softion/web-components';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly toast = inject(SofToastService);

  success(message: string, title = '¡Éxito!'): void {
    this.toast.openToast({
      title, message,
      colorType: 'success', position: 'top-right',
      progressBar: true, duration: 3500, mode: 'stack', maxStack: 3,
    });
  }

  error(message: string, title = 'Error'): void {
    this.toast.openToast({
      title, message,
      colorType: 'error', position: 'top-right',
      closeButton: true, duration: 5000, mode: 'stack', maxStack: 3,
    });
  }

  warning(message: string, title = 'Atención'): void {
    this.toast.openToast({
      title, message,
      colorType: 'warning', position: 'top-right',
      progressBar: true, duration: 5000, mode: 'stack', maxStack: 3,
    });
  }

  info(message: string, title = ''): void {
    this.toast.openToast({
      title, message,
      colorType: 'info', position: 'top-right',
      progressBar: true, duration: 3000, mode: 'stack', maxStack: 3,
    });
  }
}
